(function () {
	"use strict";

	var alertService = angular.module('alertService', []);

	alertService.constant('timeout', 4000);

	alertService.factory('AlertService', [
		'timeout', '$timeout',
		function (timeout, $timeout) {

		var forEach = angular.forEach,
			count = timeout,
			message = {
				values: {},
				timer: {},
				setVal: function (where, text) {
					var that = this,
						check = function check() {
							$timeout(function () {
								if (that.values[where] === '') {
									return;
								}
								var now = new Date().getTime();
								if ((now - that.timer[where]) >= count) {
									that.values[where] = '';
								} else {
									check();
								}
							}, 200);
						};

					this.values[where] = text;
					if (this.values[where] === '') {
						return;
					}
					this.timer[where] = new Date().getTime();
					check();
				}
			}, addProperty = function (property) {
				if (message.hasOwnProperty(property)) {
					return;
				}
				message.values[property] = '';
				message.timer[property] = 0;
				Object.defineProperty(message, property, {
					get: function () { return this.values[property]; },
					set: function (val) { this.setVal(property, val); }
				});
			};


		return {
			add: function (properties) {
				if (typeof properties === 'string') {
					properties = [properties];
				}
				if (Object.prototype.toString.call(properties) === '[object Array]') {
					forEach(properties, addProperty);
				}
			},
			setTimeout: function (timeout) {
				count = timeout;
			},
			message: message
		};

	}
	]);
}());
